import { defineMessages } from 'react-intl';

export const ImageUpload = defineMessages({
  upload: {
    id: 'app.ImageUpload.upload',
    defaultMessage: 'Nahrát',
  },
  capture: {
    id: 'app.ImageUpload.capture',
    defaultMessage: 'Vyfotit',
  },
});
